import { SelectField, type SelectFieldProps } from '@ff-it/form';
import type { ReactElement } from 'react';
import { createOptions, type Option } from 'options';
import { BlockState, blockStates } from '../block/types';
import { BlockStateTag } from './BlockStateTag';

export const blockStateOptions: Option<BlockState>[] = createOptions(blockStates);

type BlockStateProps = Omit<
  SelectFieldProps<Option<BlockState>, any, any>,
  'options' | 'loadOptions' | 'defaultOptions' | 'simple'
>;
export const formatOptionLabel = ({ value }: Option<BlockState>) => <BlockStateTag state={value} appearance="naked" />;

export function BlockStateField(props: BlockStateProps): ReactElement {
  return <SelectField options={blockStateOptions} simple formatOptionLabel={formatOptionLabel} {...props} />;
}
